import { render, staticRenderFns } from "./HtmlBg.vue?vue&type=template&id=94efbe9a&"
import script from "./HtmlBg.vue?vue&type=script&lang=js&"
export * from "./HtmlBg.vue?vue&type=script&lang=js&"
import style0 from "./HtmlBg.vue?vue&type=style&index=0&id=94efbe9a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports